import { render, staticRenderFns } from "./AddExpenseRecord.vue?vue&type=template&id=4c560367&"
import script from "./AddExpenseRecord.vue?vue&type=script&lang=js&"
export * from "./AddExpenseRecord.vue?vue&type=script&lang=js&"
import style0 from "./AddExpenseRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports